// @flow

import React, {Component} from 'react'

import api from '../../../src/api/client'

import css from './Login.css'

type Props = {
  onLogin: Function,
}
type State = {
  username: string,
  password: string,
  wasPasswordValid: boolean,
}
class Login extends Component {
  props: Props

  state: State = {
    username: '',
    password: '',
    wasPasswordValid: true,
  }

  handleUsernameChange = (e: any) => {
    this.setState({username: e.target.value, wasPasswordValid: true})
  }

  handlePasswordChange = (e: any) => {
    this.setState({password: e.target.value, wasPasswordValid: true})
  }

  login = async() => {
    try {
      const {password, username} = this.state
      const {onLogin} = this.props
      const response = await api.resources.authentication.login(
        {
          username: username,
          password: password,
        }
      )

      if(response.status === 200) {
        localStorage.setItem('token', response.token)
        localStorage.setItem('expires', response.expires)
        onLogin()
      } else {
        this.setState({wasPasswordValid: false})
      }
    } catch(e) {
      if(e.status) {
        this.setState({wasPasswordValid: false})
      } else {
        console.log(e)
      }
    }
  }

  handleEnter = (e: any) => {
    if(e.keyCode === 13) {
      this.handleSubmit(e)
    }
  }

  handleSubmit = (e: any) => {
    const {username, password} = this.state
    e.preventDefault()
    if(username && password) {
      this.login()
    }
  }

  render() {
    const {username, password, wasPasswordValid} = this.state

    return (
      <div className={css.component}>
        <div className={css.wrapper}>
          <h1 className={css.title}>Kirjaudu sisällönhallintasivulle</h1>
          <form onSubmit={this.handleSubmit}>
            <p className={css.text}>Käyttäjätunnus</p>
            <input className={css.input} type="text" value={username} onKeyUp={(e) => this.handleEnter(e)} onChange={(e) => this.handleUsernameChange(e)}/>
            <p className={css.text}>Salasana</p>
            <input className={css.input} type="password" value={password} onKeyUp={(e) => this.handleEnter(e)} onChange={(e) => this.handlePasswordChange(e)}/>
          </form>
          <button type={'button'} className={css.button} onClick={() => this.login()} disabled={!password || !username}>
            Kirjaudu
          </button>
          {!wasPasswordValid && (
            <p className={css.invalid}>Virheellinen käyttäjätunnus tai salasana</p>
          )}
        </div>
      </div>
    )
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/admin/components/Login.js